<script setup>
import notification from "@/utils/plugins/NotificationService";
import { computed, onMounted, ref } from "vue";
import { useAuthStore } from "@/app/stores/authStore";
import { useUiStore } from "@/app/stores/uiStore";

// Componentes
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import RequestTraining from "@/components/shared/Training/RequestTraining.vue";
import CourseSessionDialog from "@/components/shared/Training/CourseSessionDialog.vue";
import { Select, CloseBold } from '@element-plus/icons-vue';


import EmployeeService from '@/api/services/employee.service';
import courseEnrollmentService from "@/api/services/courseEnrollment.service";
import courseRequestService from "../../api/services/courseRequest.service";
import courseSessionsService from "@/api/services/courseSession.service";
import { filterByNormalizedText } from "@/utils/textSearch";




const authStore = useAuthStore();
const uiStore = useUiStore();

const params = ref({})
const page = ref(1);
const itemsPerPage = ref(30)


const enrollmentDataDialog = ref(false)
const selectedEnrollmentData = ref(null)


const enrollmentCancelDialog = ref(false)
const selectedEnrollmentCancel = ref(null)


const enrollmentCompleteDialog = ref(false)
const selectedEnrollmentComplete = ref(null)
const courseSessionGrade = ref(0);
const courseSessionCompletedDate = ref();
const nameEnrollment = ref('');
// eslint-disable-next-line no-unused-vars
const nameRequest = ref('');

const searchEmployee = ref(null);
const employees = ref([]);
const employeeSearchQuery = ref('');

const searchStatus = ref();
const requestStatus = ref();

const selectedCourseSession = ref();
const filteredEmployees = computed(() => {
    return filterByNormalizedText(employees.value, employeeSearchQuery.value, employee => employee.fullName);
})

const statusOptionsRequest = ref([
    {
        value: "requested",
        name: "Solicitada"
    },
    {
        value: "approved",
        name: "Aprobada"
    },
    {
        value: "rejected",
        name: "Rechazada"
    },
    {
        value: "assigned",
        name: "Asignada"
    },
    {
        value: "canceled",
        name: "Cancelada"
    },
])
const trainingName = ref();



const totalResults = ref();
const statusOptions = ref([
    {
        value: "pending",
        name: "Pendiente"
    },
    {
        value: "confirmed",
        name: "Confirmado"
    },
    {
        value: "completed",
        name: "Completado"
    },
    {
        value: "canceled",
        name: "Cancelado"
    },
])


const filter = ref([
    {
        name: "Realizados",
        active: true,
    }, {
        name: "Solicitados",
        active: false,
    }])


const filteredCourseEnrollments = ref([]);



const dialogRequestTraining = ref(false);

const filteredCourseRequests = ref([]);
const selectedRequest = ref();

const courseSessionCompleteDateError = ref(false)

const user = computed(() => {
    return authStore.getUserLogged;
})

const isAdmin = computed(() => {
    if (user.value) {
        return user.value.roles.includes('ROLE_ADMIN');
    }
    return false;
})



// eslint-disable-next-line no-unused-vars
const getActiveFilter = computed(() => {
    const activeItem = filter.value.find(item => item.active)
    return activeItem ? activeItem.name : null
})


// eslint-disable-next-line no-unused-vars
const isEnrolled = computed(() => {
    const session = selectedCourseSession.value;

    if (!session || !Array.isArray(session.enrollments)) {
        return false;
    }

    return session.enrollments.some(enroll => {
        const emp = enroll.employee;
        if (emp && emp['@id']) {
            return emp['@id'] === user.value['@id']
        }
        return false;
    })
})

onMounted(async () => {
    await startData();
})


const startData = async () => {
    const requests = [getCourseEnrollment(), getCourseRequests()];
    if (isAdmin.value) {
        requests.push(getEmployees());
    }
    await Promise.all(requests);
}
const changeFilter = (index) => {
    filter.value.forEach((item, i) => {
        item.active = i === index
    })
}

const getEmployees = async () => {
    const par = {
        'order[name]': 'asc',
        'active': 1,
        page: 1,
        itemsPerPage: 999999,
    };
    uiStore.startLoading();
    try {
        const res = await EmployeeService.getEmployees(par);
        employees.value = res.data['hydra:member'];
    } finally {
        uiStore.stopLoading();
    }
}
const filterEmployeesByName = (query) => {
    employeeSearchQuery.value = query;
}

const getCourseEnrollment = async () => {
    uiStore.startLoading();
    try {
        const res = await courseEnrollmentService.getCoursesEnrollment(params.value);
        if (res.status === 200) {
            totalResults.value = res.data['hydra:totalItems']
            filteredCourseEnrollments.value = res.data['hydra:member']
        }
        params.value.name = "";
    } finally {
        uiStore.stopLoading();
    }
}

const getCourseRequests = async () => {
    uiStore.startLoading();
    try {
        const res = await courseRequestService.getCourseRequests(params.value);
        if (res.status === 200) {
            totalResults.value = res.data['hydra:totalItems']
            filteredCourseRequests.value = res.data['hydra:member']
        }
        params.value.name = "";
    } finally {
        uiStore.stopLoading();
    }
}


const searchEnrollment = () => {
    params.value = {
        page: page.value,
        itemsPerPage: itemsPerPage.value,
        'order[assignedAt]': "ASC",
        'session.course.name': nameEnrollment.value,
        status: searchStatus.value,
        "employee.email": searchEmployee.value,
    }

    getCourseEnrollment();
}
const searchRequests = () => {
    params.value = {
        page: page.value,
        itemsPerPage: itemsPerPage.value,
        'order[assignedAt]': "ASC",
        'course.name': nameRequest.value,
        status: requestStatus.value,
    }
    getCourseRequests();
}

const getStatus = (status) => {
    switch (status) {
        case "pending":
            return "Pendiente";
        case "confirmed":
            return "Confirmado";
        case "completed":
            return "Completado";
        case "canceled":
            return "Cancelado";
        default:
            return "Otro";
    }
}

const getStatusRequest = (status) => {
    switch (status) {
        case "requested":
            return "Solicitada";
        case "approved":
            return "Aprobada";
        case "rejected":
            return "Rechazada";
        case "assigned":
            return "Asignada";
        case "canceled":
            return "Cancelado";
        default:
            return "Otro";
    }
}

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // formato 24 h
    };

    return date.toLocaleString('es-ES', options).replace(',', '');
}

const openEnrollmentDataDialog = (enrollment) => {
    selectedEnrollmentData.value = enrollment;
    enrollmentDataDialog.value = true;
}
const openEnrollmentDataMobile = (enrollment) => {
    if (window.matchMedia('(max-width: 767px)').matches) {
        openEnrollmentDataDialog(enrollment);
    }
}
const closeEnrollmentDataDialog = () => {
    selectedEnrollmentData.value = null;
    enrollmentDataDialog.value = false;
}

const openEnrollmentCompleteDialog = (enrollment) => {
    selectedEnrollmentComplete.value = enrollment;
    enrollmentCompleteDialog.value = true;
}
const closeEnrollmentCompleteDialog = () => {
    courseSessionCompletedDate.value = null;
    courseSessionGrade.value = 0;
    selectedEnrollmentComplete.value = null;
    enrollmentCompleteDialog.value = false;
}


const completeCourseSession = async () => {
    if (!courseSessionGrade.value) {
        courseSessionGrade.value = 0;
    }
    if (!selectedEnrollmentComplete.value) {
        notification.addNotification({
            message: 'Ha habido un problema',
            type: 'error'
        });
        return;
    }
    if (!courseSessionCompletedDate.value) {
        courseSessionCompleteDateError.value = true;
        return;
    }
    const paramsComplete = {
        grade: courseSessionGrade.value,
        completedAt: formatDateComplete(new Date(courseSessionCompletedDate.value)),
    }
    uiStore.startLoading();
    try {
        const res = await courseSessionsService.completeCourseSession(selectedEnrollmentComplete.value.session.id, paramsComplete);
        if (res.status === 200) {
            notification.addNotification({
                message: 'Has completado el curso sin problema',
                type: 'success'
            });
        }
        await getCourseEnrollment();
        closeEnrollmentCompleteDialog();
    } catch {
        closeEnrollmentCompleteDialog();
    } finally {
        uiStore.stopLoading();
    }
}


const openEnrollmentCancelDialog = (enrollment) => {
    selectedEnrollmentCancel.value = enrollment;
    enrollmentCancelDialog.value = true;
}
const closeEnrollmentCancelDialog = () => {
    selectedEnrollmentCancel.value = null;
    enrollmentCancelDialog.value = false;
}

const cancelCourseSession = async () => {
    if (!selectedEnrollmentCancel.value) {
        notification.addNotification({
            message: 'Ha habido un problema',
            type: 'error'
        });
        return;
    }
    if (isAdmin.value) {
        await cancelRequestAdmin(selectedEnrollmentCancel.value)
        return;
    }
    uiStore.startLoading();
    try {
        const res = await courseSessionsService.cancelCourseSession(selectedEnrollmentCancel.value.session.id);
        if (res.status === 204) {
            notification.addNotification({
                message: 'Has cancelado tu inscripción al curso',
                type: 'success'
            });
        }
        await getCourseEnrollment();
        closeEnrollmentCancelDialog();
    } catch {
        notification.addNotification({
            message: 'Ha habido un problema al completar el curso',
            type: 'error'
        });
        closeEnrollmentCancelDialog();
    } finally {
        uiStore.stopLoading();
    }
}

const openDialogRequestTraining = () => {
    dialogRequestTraining.value = true;
}


const closeDialogRequestTraining = () => {
    dialogRequestTraining.value = false;
    selectedRequest.value = null;
}

const editRequest = (request) => {
    selectedRequest.value = request;
    openDialogRequestTraining();
}

const editRequestMobile = (request) => {
    if (window.matchMedia('(max-width: 767px)').matches) {
        editRequest(request);
    }
}

const formatDateComplete = (date) => {
    // Obtener el desplazamiento de la zona horaria
    const offset = new Date().getTimezoneOffset();
    const sign = offset > 0 ? '-' : '+';
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
    const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
    // Formato de fecha
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    // Formato de hora
    const hoursOfDay = String(date.getHours()).padStart(2, '0');
    const minutesOfDay = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    // Devolver la cadena en formato ISO con el desplazamiento de la zona horaria
    return `${year}-${month}-${day}T${hoursOfDay}:${minutesOfDay}:${seconds}${sign}${hours}:${minutes}`;
}

const confirmRequest = async (courseEnrollment) => {
    if (!courseEnrollment) {
        notification.addNotification({
            message: 'Ha habido un problema',
            type: 'error'
        });
        return;
    }
    uiStore.startLoading();
    try {
        const res = await courseEnrollmentService.confirmCourseEnrollment(courseEnrollment.id, {});
        console.log(res.status);
        if (res && res.status && (res.status === 200 || res.status === 201)) {
            notification.addNotification({
                message: 'Has confirmado la solicitud',
                type: 'success'
            });
        }
        await getCourseEnrollment();
    } catch {
        notification.addNotification({
            message: 'Ha habido un problema al completar el curso',
            type: 'error'
        });
    } finally {
        uiStore.stopLoading();
    }
}
const cancelRequestAdmin = async (courseEnrollment) => {
    console.log(courseEnrollment);
    if (!courseEnrollment) {
        notification.addNotification({
            message: 'Ha habido un problema',
            type: 'error'
        });
        return;
    }
    uiStore.startLoading();
    try {
        const res = await courseEnrollmentService.cancelCourseEnrollment(courseEnrollment.id, {});
        if (res && res.status && (res.status === 200 || res.status === 201)) {
            notification.addNotification({
                message: 'Has cancelado la solicitud',
                type: 'success'
            });
        }
        await getCourseEnrollment();
        closeEnrollmentCancelDialog();
    } catch {
        notification.addNotification({
            message: 'Ha habido un problema al completar el curso',
            type: 'error'
        });
        closeEnrollmentCancelDialog();
    } finally {
        uiStore.stopLoading();
    }
}

const returnStatusClass = (enrollment) => {
    switch (enrollment.status) {
        case "completed":
            return "status-completed";
        case "confirmed":
            return "status-confirmed";
        case "canceled":
            return "status-canceled";
        case "pending":
            return "status-pending";
        default:
            return "";
    }
};

</script>

<template>
    <div>
        <div>
            <header-title title="Talento" />
            <div class="d-flex row">
                <div class="d-flex flex-row justify-content-start el-col-xs-24 col-md-6">
                    <!-- TODO: Cambiar svg -->
                    <img style="width: 35px;" src="@/assets/icons/graduating-hat-blue.svg">
                    <div class="title-text pl-4">
                        Formación
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-end el-col-xs-24 col-md-6">
                    <div class="filter-options">
                        <template v-for="(item, index) in filter" :key="index">
                            <span class="option" :class="{ active: item.active }" @click="changeFilter(index)">
                                {{ item.name }}
                            </span>
                            <span v-if="index < filter.length - 1" class="separator">|</span>
                        </template>
                    </div>
                </div>
            </div>
            <div v-if="getActiveFilter === 'Realizados'">
                <!-- Barra de busqueda -->
                <el-row class="mt-2">
                    <el-card class="card-search card-abs w-100 wback" body-style="padding:0">

                        <div class="search-form">
                            <div class="row">
                                <div class="col-md-4 col-xs-12">
                                    <div class="form-item">
                                        <label>Nombre del curso</label>
                                        <el-input v-model="nameEnrollment" placeholder="Buscar por nombre" clearable
                                            @change="searchEnrollment()">
                                        </el-input>
                                    </div>
                                </div>
                                <div :class="isAdmin ? 'col-md-2' : 'col-md-4'" class="col-xs-12">
                                    <div class="form-item">
                                        <label class="w-100">Estado</label>
                                        <el-select v-model="searchStatus" placeholder="Todos" filterable clearable
                                            @change="searchEnrollment()">
                                            <el-option v-for="status in statusOptions" :key="status.value"
                                                :label="status.name" :value="status.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="col-md-3 col-xs-12" v-if="isAdmin">
                                    <div class="form-item">
                                        <label class="w-100">Empleado</label>
                                        <el-select v-model="searchEmployee" placeholder="Todos" filterable clearable
                                            :filter-method="filterEmployeesByName"
                                            @change="searchEnrollment()">
                                            <el-option v-for="employee in filteredEmployees" :key="employee['@id']"
                                                :label="employee.fullName" :value="employee.email">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div :class="isAdmin ? 'col-md-3' : 'col-md-4'" class="el-col-xs-24">
                                    <div class="d-flex justify-content-end">
                                        <!-- <div class="col-md-6 align-self-center ">
                                        <button type="submit" class="btn btn_red btn__new" @click="newCourse()">
                                            CREAR
                                        </button>
                                    </div> -->
                                        <div
                                            class="col-md-12 align-self-end justify-content-end el-col-xs-24 course-search-buttons">
                                            <button type="submit" @click="searchEnrollment()"
                                                class="btn btn_yellow btn__search" style="max-width: 200px;">
                                                BUSCAR
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </el-card>
                </el-row>
                <!-- Tabla cursos-->
                <el-row v-for="enrollment in filteredCourseEnrollments" :key="enrollment.id">
                    <div class="card card-course w-100 pt-2 px-2 mt-2 justify-content-center"
                        @click="openEnrollmentDataMobile(enrollment)">
                        <div class="d-flex align-items-center justify-content-center card-course-item"
                            style="margin-top: -7px;">
                            <div class="d-flex align-items-center col-md-4 el-col-xs-24">
                                <img style="width: 30px; margin-right: 7px;"
                                    src="@/assets/icons/graduating-hat-blue.svg">
                                <span class="title-course">{{ enrollment.session ? enrollment.session.course ?
                                    enrollment.session.course.name :
                                    'Nombre del curso' : 'Nombre del curso' }}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-end col-md-5 el-col-xs-24 course-item"
                                style="margin-right: 4px;">
                                <div class="d-flex status-container align-items-end mb-0 mb-sm-0 justify-content-end col-md-6"
                                    style="margin-left: -15px;margin-right: 15px;">
                                    <span :class="returnStatusClass(enrollment)">
                                        {{ getStatus(enrollment.status) }}
                                    </span>
                                </div>
                                <div class="dates-container d-flex align-items-center mb-0 mb-sm-2 col-md-6">
                                    <el-divider class="col-auto justify-content-center" direction="vertical"
                                        style="margin: 0; height: 45px;"></el-divider>
                                    <b class="time-course">{{ formatDate(enrollment.session.startAt) }}</b>
                                    <el-divider class="col-auto justify-content-center" direction="vertical"
                                        style="margin: 0; height: 45px;"></el-divider>
                                    <b class="time-course">{{ enrollment.session.endAt ?
                                        formatDate(enrollment.session.endAt) : 'Duración indefinida' }}</b>
                                    <el-divider class="col-auto course-item-divider" direction="vertical"
                                        style="margin: 0; height: 45px;"></el-divider>
                                </div>
                            </div>
                            <div class="d-flex col-md-2 el-col-xs-24 course-item-employee">
                                {{ isAdmin && enrollment.employee != null ? enrollment.employee.fullName : '' }}
                            </div>
                            <div
                                class="d-flex align-items-center date-presence justify-content-end col-md-1 el-col-xs-24">
                                <!-- Botón ver -->
                                <div class="pointer course-open-action" style="margin-right: 6px;">
                                    <font-awesome-layers class="fa-2x" style="margin-left: 5px" title="Completar"
                                        @click.stop="openEnrollmentDataDialog(enrollment)">
                                        <font-awesome-icon icon="circle" style="color: #f7d20e" />
                                        <font-awesome-icon icon="eye" class="fa-inverse" transform="shrink-6"
                                            style=" margin-left: -1.45px;" />
                                    </font-awesome-layers>
                                </div>
                                <!-- Boton aceptar -->
                                <el-button class="btn align-self-center justify-content-end" :icon="Select" circle
                                    title="Aprobar solicitud" v-if="isAdmin && enrollment.status === 'pending'"
                                    @click.stop="confirmRequest(enrollment)"
                                    style="margin-left: -3px; margin-right: 0px; color: #fff; background-color: #474ce6;" />
                                <!-- Botón cancelar -->
                                <div class="pointer">
                                    <el-button class="btn align-self-center justify-content-end" circle
                                        v-if="enrollment.status === 'pending'" :icon="CloseBold"
                                        @click.stop="openEnrollmentCancelDialog(enrollment)"
                                        style="margin-left: 3px; margin-right: 3px; color: #fff; background-color: #f9156f;"
                                        title="Cancelar solicitud" />
                                    <!-- <font-awesome-layers class="fa-2x" style="margin-left: 5px" title="Editar"
                                    @click="openEnrollmentCancelDialog(enrollment)">
                                    <font-awesome-icon icon="circle" style="color: red" />
                                    <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
                                </font-awesome-layers> -->
                                </div>
                                <!-- Botón completar -->
                                <div class="pointer"
                                    v-if="!isAdmin && enrollment.status === 'confirmed' && enrollment.session && (enrollment.session.status === 'published' || enrollment.session.status === 'ongoing')">
                                    <button class="btn btn_green" @click.stop="openEnrollmentCompleteDialog(enrollment)"
                                        style="width: 130px; margin-right: 6px;">
                                        Completar
                                    </button>
                                    <!-- <font-awesome-layers class="fa-2x" style="margin-left: 5px" title="Cancelar"
                                    @click="openEnrollmentCompleteDialog(enrollment)">
                                    <font-awesome-icon icon="circle" style="color: green" />
                                    <font-awesome-icon icon="check" class="fa-inverse" transform="shrink-6" />
                                </font-awesome-layers> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </el-row>
            </div>
            <div v-if="getActiveFilter === 'Solicitados'">
                <!-- Barra de busqueda -->
                <el-row class="mt-2">
                    <el-card class="card-search card-abs w-100 wback" body-style="padding:0">

                        <div class="search-form">
                            <div class="row">
                                <div class="col-md-4 el-col-xs-24">
                                    <div class="form-item">
                                        <label>Nombre del curso</label>
                                        <el-input v-model="trainingName" placeholder="Buscar por nombre" clearable
                                            @change="searchRequests()">
                                        </el-input>
                                    </div>
                                </div>
                                <div class="col-md-4 el-col-xs-24">
                                    <div class="form-item">
                                        <label class="w-100">Estado</label>
                                        <el-select v-model="requestStatus" placeholder="Todos" filterable clearable
                                            @change="searchRequests()">
                                            <el-option v-for="item in statusOptionsRequest" :key="item.value"
                                                :label="item.name" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="col-md-4 el-col-xs-24">
                                    <div class="d-flex justify-content-center course-search-buttons">
                                        <div class="col-md-6 align-self-center el-col-xs-24">
                                            <button type="submit" class="btn btn_red btn__new"
                                                @click="openDialogRequestTraining()">
                                                SOLICITAR
                                            </button>
                                        </div>
                                        <div class="col-md-6 align-self-center el-col-xs-24">
                                            <button type="submit" @click="searchRequests()"
                                                class="btn btn_yellow btn__search">
                                                BUSCAR
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </el-card>
                </el-row>
                <!-- Tabla cursos-->
                <el-row v-for="course in filteredCourseRequests" :key="course.id">
                    <div class="card card-course w-100 pt-2 px-2 mt-2 justify-content-center"
                        @click="editRequestMobile(course)">
                        <div class="d-flex align-items-center justify-content-center card-course-item "
                            style="margin-top: -7px;">
                            <div class="d-flex align-items-center col-md-5 el-col-xs-24">
                                <img style="width: 30px; margin-right: 7px;"
                                    src="@/assets/icons/graduating-hat-blue.svg">
                                <span class="title-course">{{ course.course ? course.course.name : course.requestedTitle
                                    }}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-end col-md-1 el-col-xs-24 card-course-session-hour"
                                style="margin-right: 10px;">
                                <el-divider class="col-auto course-item-divider" direction="vertical"
                                    style="margin: 0; height: 45px;"></el-divider>
                                <b class="time-course">{{ getStatusRequest(course.status) }}</b>
                                <el-divider class="col-auto course-item-divider" direction="vertical"
                                    style="margin: 0; height: 45px;"></el-divider>
                            </div>
                            <div class="d-flex justify-content-center align-content-center el-col-xs-24 course-request-note"
                                :class="isAdmin ? 'col-md-3' : 'col-md-5'" style="margin-right: 10px;">
                                <span class="employee-text justify-content-center align-content-center">
                                    {{ course.note != '' ? course.note : 'No hay anotaciones' }}
                                </span>
                                <div style="margin-left: 5px;">
                                    <el-divider class="col-auto course-item-divider" direction="vertical"
                                        style="margin: 0; height: 45px;"></el-divider>
                                </div>
                            </div>
                            <div class="d-flex col-md-2 el-col-xs-24 course-item-employee" v-if="isAdmin"
                                style="margin-right: 10px;">
                                {{ course.employee.fullName }}
                            </div>
                            <div class="d-flex align-items-center date-presence justify-content-end col-md-1 el-col-xs-24"
                                style="margin-left: -20px;">
                                <div class="pointer course-open-action">
                                    <font-awesome-layers class="fa-2x" style="margin-left: 5px" title="Editar"
                                        @click.stop="editRequest(course)">
                                        <font-awesome-icon icon="circle" style="color: #f7d20e" />
                                        <font-awesome-icon icon="eye" class="fa-inverse" transform="shrink-6"
                                            style=" margin-left: -1.45px;" />
                                    </font-awesome-layers>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-row>
            </div>
        </div>
        <!-- Dialog Solicitud -->
        <el-dialog v-model="dialogRequestTraining" :show-close="false" :lock-scroll="true" width="700"
            style="border-radius: 20px;" class="request-course-dialog" @close="closeDialogRequestTraining">
            <!-- Mi material // Datos material -->
            <RequestTraining v-if="dialogRequestTraining" @reload="getCourseRequests" :request="selectedRequest"
                @closeDialog="closeDialogRequestTraining" />
        </el-dialog>
        <!-- Dialog datos sesion -->
        <el-dialog v-model="enrollmentDataDialog" width="600" :show-close="false" :lock-scroll="true"
            style="border-radius: 20px;" @close="closeEnrollmentDataDialog">
            <!-- Mi material // Datos material -->
            <CourseSessionDialog v-if="enrollmentDataDialog && selectedEnrollmentData" :session="selectedEnrollmentData"
                @reload="getCourseEnrollment" @close-dialog="closeEnrollmentDataDialog" />
        </el-dialog>
        <!-- Dialog completar curso -->
        <el-dialog v-model="enrollmentCompleteDialog" width="650" :show-close="false" :lock-scroll="true"
            style="border-radius: 20px;" @close="closeEnrollmentCompleteDialog">
            <div v-if="selectedEnrollmentComplete">
                <h2 class="bg-title-course">Completar curso</h2>
                <div class="f-flex row">
                    <div class="col-12">
                        <span class="title-course">{{ selectedEnrollmentComplete.session.course.name }}</span>
                    </div>
                    <div class="el-col-xs-24 col-md-12"
                        v-if="selectedEnrollmentComplete.session && selectedEnrollmentComplete.session.course && selectedEnrollmentComplete.session.course.description">
                        <label class="w-100" for="description">Descripci&oacute;n</label>
                        <textarea v-model="selectedEnrollmentComplete.session.course.description" id="description"
                            class="w-100 p-3 font18" disabled />
                    </div>
                    <div class="el-col-xs-24 col-md-6" v-if="selectedEnrollmentComplete.session.startAt">
                        <div class="form-item date-picker">
                            <label class="mb-2 w-100" for="dateStart">Fecha inicio</label>
                            <el-date-picker class="w-100" v-model="selectedEnrollmentComplete.session.startAt"
                                type="date" disabled id="dateStart" />
                        </div>
                    </div>
                    <div class="el-col-xs-24 col-md-6" v-if="selectedEnrollmentComplete.session.endAt">
                        <div class="form-item date-picker">
                            <label class="mb-2 w-100" for="dateEnd">Fecha fin</label>
                            <el-date-picker class="w-100" v-model="selectedEnrollmentComplete.session.endAt" type="date"
                                disabled id="dateEnd" />
                        </div>
                    </div>
                    <div class="col-md-5 mt-4 el-col-xs-24">
                        <label for="input-grade" class="w-100">Nota en el curso (sobre 100): </label>
                        <el-input-number id="input-grade" v-model="courseSessionGrade" class="search-input"
                            style="width: 100%;" :min="0" :max="100" placeholder="Indique la nota. Número del 0 al 100"
                            :controls="false" />
                    </div>
                    <div class="col-md-7 mb-4  el-col-xs-24">
                        <div class="form-item date-picker mt-4 w-100 label-common pl-5">
                            <label for="completedCourse" class="w-100">Fecha en la que se completó el curso:</label>
                            <el-date-picker id="completedCourse" v-model="courseSessionCompletedDate"
                                name="completed-date'" type="datetime" style="width: 100%;"
                                placeholder="Fecha completado" format="DD/MM/YYYY HH:mm" value-format="YYYY-MM-DD HH:mm"
                                :picker-options="{ firstDayOfWeek: 1 }" />
                            <p v-if="courseSessionCompleteDateError" class="invalid-feedback mb-0 mt-2">
                                <small>
                                    {{ 'Inserte la fecha de fin' }}
                                </small>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row item justify-content-end" style="margin-right: 5px;">
                    <div class="col-sm-5 el-col-xs-24" style="margin-bottom: 5px;">
                        <button class="btn btn_red" @click="closeEnrollmentCompleteDialog()">
                            Volver
                        </button>
                    </div>
                    <div class="col-sm-5 el-col-xs-24">
                        <button class="btn btn_green" @click="completeCourseSession();">
                            Completar
                        </button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- Dialog cancelar curso -->
        <el-dialog v-model="enrollmentCancelDialog" width="500" :show-close="false" :lock-scroll="true"
            style="border-radius: 20px;" @close="closeEnrollmentCancelDialog">
            <div v-if="selectedEnrollmentCancel">
                <h2 class="bg-title-course">Deseas cancelar la inscripción a este curso</h2>
                <div class="f-flex">
                    <div class="col-12">
                        <span class="title-course">{{ selectedEnrollmentCancel.session.course.name }}</span>
                    </div>
                </div>
                <div class="row d-flex mb-3">
                    <div class="el-col-xs-24 col-md-12"
                        v-if="selectedEnrollmentCancel.session && selectedEnrollmentCancel.session.course && selectedEnrollmentCancel.session.course.description">
                        <label class="w-100" for="description">Descripci&oacute;n</label>
                        <textarea v-model="selectedEnrollmentCancel.session.course.description" id="description"
                            class="w-100 p-3 font18" disabled />
                    </div>
                    <div class="el-col-xs-24 col-md-6" v-if="selectedEnrollmentCancel.session.startAt">
                        <div class="form-item date-picker">
                            <label class="mb-2 w-100" for="dateStart">Fecha inicio</label>
                            <el-date-picker class="w-100" v-model="selectedEnrollmentCancel.session.startAt" type="date"
                                disabled id="dateStart" />
                        </div>
                    </div>
                    <div class="el-col-xs-24 col-md-6" v-if="selectedEnrollmentCancel.session.endAt">
                        <div class="form-item date-picker">
                            <label class="mb-2 w-100" for="dateEnd">Fecha fin</label>
                            <el-date-picker class="w-100" v-model="selectedEnrollmentCancel.session.endAt" type="date"
                                disabled id="dateEnd" />
                        </div>
                    </div>
                </div>
                <div class="row item justify-content-end" style="margin-right: 5px;">
                    <div class="col-sm-5" style="margin-bottom: 5px;">
                        <button class="btn btn_yellow" @click="closeEnrollmentCancelDialog()">
                            Volver
                        </button>
                    </div>
                    <div class="col-sm-5">
                        <button class="btn btn_red" @click="cancelCourseSession();">
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
.filter-options {
    font-weight: bold;
    font-size: 32px;
}

.option {
    cursor: pointer;
    color: #3B47FF;
    /* Azul por defecto */
    margin: 0 0.2em;
    font-size: 20px;
}

.option.active {
    color: #FF006E;
    /* Rosa cuando está activo */
}

.separator {
    color: #3B47FF;
    /* Separador siempre azul */
    margin: 0 0.2em;
}

.btn__search,
.btn__new {
    height: 3em;
    margin-top: 22px;
}

.card-course {
    min-height: 71px;
    border-radius: 20px;
}

.title-course {
    font-weight: 800;
    font-size: 18px;
    color: #3B47FF;
}

.bg-title-course {
    font-weight: 800;
    color: #3B47FF;
}

.time-course {
    font-weight: 600;
    font-size: 13px;
    color: #3B47FF;
    margin-right: 7px;
    margin-left: 7px;
    text-align: center;
}

.employee-text {
    align-items: center;
    align-content: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.status-confirmed,
.status-completed,
.status-pending,
.status-canceled {
    display: inline-block;
    padding: 0.35rem 0.75rem;
    border-radius: 0.375rem;
    font-weight: 600;
    font-size: 0.95rem;
    color: #fff;
    text-align: center;
    text-transform: uppercase;
}

.status-pending {
    background-color: #f1c40f;
}

.status-completed,
.status-confirmed {
    background-color: #27ae60;
}

.status-canceled {
    background-color: #E53935;
}

@media (max-width: 767px) {
    .card-course {
        cursor: pointer;
        position: relative;
    }

    .course-open-action {
        display: none;
    }

    .date-presence {
        position: absolute;
        right: 12px;
        top: 10px;
        width: auto !important;
        z-index: 1;
    }

    .date-presence .btn_green {
        width: auto !important;
        min-width: 110px;
    }

    .card-course-item {
        padding-right: 150px;
    }
}
</style>
